// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"fe374a1c","363":"fa4eb498","552":"89951aeb","945":"fe374a1c"}[chunkId] + ".chunk.css";
};